import superagent from 'superagent'

export const SUBSCRIPTION_PLANS_SET = 'SUBSCRIPTION_PLANS_SET'

export const subscriptionPlansSet = subscriptionPlans => {
  return {
    type: SUBSCRIPTION_PLANS_SET,
    payload: subscriptionPlans
  }
}

export const subscriptionPlansFetchRequest = () => (dispatch, getState, token) => {
  return new Promise(resolve => {
    superagent
      .get(`${__API_URI__}/SubscriptionPlan/Get`)
      .set('Authorization', `Bearer ${null}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          if (err.status == 401) {
            resolve(err.status)
          }
          return
        }
        dispatch(subscriptionPlansSet(res.body))
        resolve(res.body)
      })
  })
}
